export const RosettaRequiredError = () => (
  <div className="flex flex-col gap-y-3">
    <div>This package requires Rosetta 2 to be installed.</div>
    <div>Please install it manually by running in terminal</div>
    <input
      className="relative rounded bg-muted p-2 font-mono outline-gray-300"
      value="softwareupdate --install-rosetta --agree-to-license"
      readOnly
    />
    <div>
      <a
        href="https://www.macobserver.com/tips/how-to/install-rosetta-2-on-apple-silicon-macs-m1-m2-and-m3/"
        target="_blank"
        rel="noreferrer"
        className="underline text-blue-500"
      >
        Learn more
      </a>
    </div>
  </div>
)
